/**
 * 완료 탭(searchStatus === 'COMPLETED') 안에서 "콘텐츠 제출 기한 경과(미제출)" 아이템을 판정한다.
 *
 * BE(QAT-39765): 선정·수락된 채 콘텐츠를 제출하지 못하고 마감된 건을 **완료 탭으로 이동**시키되
 * 참여상태(`participationStatus`)는 `'CONFIRMED'` 로 유지한다. 제출 완료건은 `'COMPLETED'`.
 * 따라서 완료 탭 안에서 "정상 완료" 와 "기한 경과" 는 `participationStatus` 로만 구분된다.
 *
 * ⚠️ **완료 탭 한정 판정.** 다른 탭에선 `'CONFIRMED'` 의미가 다르므로(진행 중) 호출부에서
 * 반드시 `status === 'COMPLETED'` 가드 안에서만 사용해야 한다. (QAT-39690 §3 / CMQA-7189·7190)
 */
export const isSeedingContentDeadlineExpired = (item: { participationStatus: string }): boolean =>
  item.participationStatus === 'CONFIRMED';
